






















// @ is an alias to /src
import { AloBaseLg, getDefaultAloBaseLg } from '@/models/alo/AloBaseLg'; 
import deepEqual from 'deep-equal'
import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({
  name: 'SelectFromList',    
  props: {
    title:String,
    subtitle:String,
    value:Boolean,
    persistent:{
      type:Boolean,
      default:true
    },
    selectedItem:{
      type:Object,
      default:() => {return {lgs:[]}}
    },
    width:{
      type:String,
      default:"1200"
    },
    items:{
      type:Array,
      required:true,
      default:()=>[]
    }    
  }
})
export default class EditDrawerContent extends Vue {
  title!:string
  subtitle!:string
  value!:boolean
  persistent!:boolean
  selectedItem!:{lgs:Array<AloBaseLg>}
  items!:Array<{lgs:Array<AloBaseLg>}>
  width!:string

  selected = -1
  
  @Watch("showDialog")
  onShowDialogChanged(){
    if(this.showDialog) this.selected = this.items.findIndex(it => deepEqual(this.selectedItem,it))
  }

  get deepEqual()
  {
    return deepEqual
  }

  get showDialog(){
    return this.value
  }

  set showDialog(value){
    this.$emit('input', value)
    if(!value) this.$emit("cancel")
  }
  
  valid() {
    this.showDialog = false
    this.$emit("select",this.items[this.selected]) 
  }  

}
